import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { FiImage } from "react-icons/fi";

const Box = styled.span`
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
  > svg {
    width: 28px;
    height: 28px;
    color: ${(p) => p.theme.colors.textMuted};
  }
`;

/** Картинка предмета с резервом размера и запасным значком при ошибке загрузки. */
export default function ItemImage({
  src,
  alt,
}: {
  src?: string;
  alt: string;
}) {
  const [failed, setFailed] = useState(false);
  useEffect(() => setFailed(false), [src]);
  return (
    <Box>
      {src && !failed ? (
        <img
          src={src}
          alt={alt}
          loading="lazy"
          decoding="async"
          onError={() => setFailed(true)}
        />
      ) : (
        <FiImage role="img" aria-label={alt} />
      )}
    </Box>
  );
}
